import React from 'react';
import {TableBasic} from './styles';

export default () => (
  <TableBasic>
    <thead>
      <tr>
        <th colSpan={6} className="header-centered left-radio">
          SEASON
        </th>
      </tr>
      <tr>
        <th className="header-centered">DATES</th>
        <th className="header-centered">EVENT</th>
        <th className="header-centered">PITCHES</th>
        <th className="header-centered">INNINGS</th>
        <th className="header-centered">STRIKE %</th>
        <th className="header-centered">NOTES</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
      <tr>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
        <td>1599</td>
      </tr>
    </tbody>
  </TableBasic>
);
